import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';
import { STUDENT, TUTOR } from '../../util/types';

const Tab = props => {
  const { className, id, disabled, text, selected, linkProps, userType, tabCompletedMaybe } = props;
  const linkClasses = classNames(css.link, {
    [css.selectedListingLink]: userType ? selected : null,
    [css.selectedLink]: userType ? null : selected,
    [css.studentLinkWhite]: userType == TUTOR,
    [css.disabled]: disabled,
    [css.studentLink]: userType == STUDENT,
    [css.tabCompleted]: (tabCompletedMaybe),
  });

  return (
    <div id={id} className={className}>
      <NamedLink className={linkClasses} {...linkProps}>
        {text}
      </NamedLink>
    </div>
  );
};

Tab.defaultProps = { className: null, disabled: false, selected: false };

const { arrayOf, bool, node, object, string } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
};

const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs, userType, tabStatusCompleted={} } = props;
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;

  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        const tabCompletedMaybe = tabStatusCompleted[tab?.tab];
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return <Tab key={id} id={id} className={tabClasses} {...tab} userType={userType} tabCompletedMaybe={tabCompletedMaybe} />;
      })}
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
  tabClassName: null,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
};

export default TabNav;
